import { render, staticRenderFns } from "./BottomWaypoints.vue?vue&type=template&id=6b7b6f0b&"
import script from "./BottomWaypoints.vue?vue&type=script&lang=js&"
export * from "./BottomWaypoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7b6f0b')) {
      api.createRecord('6b7b6f0b', component.options)
    } else {
      api.reload('6b7b6f0b', component.options)
    }
    module.hot.accept("./BottomWaypoints.vue?vue&type=template&id=6b7b6f0b&", function () {
      api.rerender('6b7b6f0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/BottomWaypoints.vue"
export default component.exports